import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type UserPermissions = Record<string, unknown>;

export interface PermissionState {
  permissions: UserPermissions;
}

const initialState: PermissionState = {
  permissions: {},
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<UserPermissions>) => {
      state.permissions = action.payload;
    },
    clearPermissions: () => initialState,
  },
});

export const { setPermissions, clearPermissions } = permissionSlice.actions;

export const selectHasPermission = (permissions: UserPermissions, shortcode: string): boolean => {
  const perm = permissions[shortcode];
  if (perm === true) return true;
  if (perm && typeof perm === "object" && (perm as { has_permission?: boolean }).has_permission) {
    return true;
  }
  const nested = (permissions as { permissions?: Record<string, boolean> })?.permissions;
  return !!nested?.[shortcode];
};

export default permissionSlice.reducer;
